var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-inner" },
    [
      _c(
        "q-toolbar",
        { staticClass: "sl-footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _vm.selectedTab === "managers" && _vm.selectedManagers.length !== 0
            ? _c("q-btn", {
                attrs: { label: "Remove Selected", color: "red" },
                on: {
                  click: function($event) {
                    _vm.onRemoveManagers()
                  }
                }
              })
            : _vm._e(),
          _vm.selectedTab === "affiliates" &&
          _vm.selectedAffiliates.length !== 0
            ? _c("q-btn", {
                attrs: { label: "Remove Selected", color: "red" },
                on: {
                  click: function($event) {
                    _vm.onRemoveAffiliates()
                  }
                }
              })
            : _vm._e(),
          _c("q-toolbar-title"),
          _vm.mode === "edit" && _vm.selectedTab === "documents"
            ? _c(
                "div",
                { staticClass: "q-px-sm" },
                [
                  _c("q-btn", {
                    staticClass: "q-px-md",
                    attrs: { label: "Upload", color: "green" },
                    on: {
                      click: function($event) {
                        _vm.openUploadModal()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.mode === "edit"
            ? _c(
                "div",
                { staticClass: "q-px-sm" },
                [
                  _c("q-btn", {
                    staticClass: "q-px-md",
                    attrs: {
                      color: "green",
                      label: "Save",
                      disable: _vm.$v.courseForm.$invalid
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.update()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.mode === "add"
            ? _c(
                "div",
                { staticClass: "q-px-sm" },
                [
                  _c("q-btn", {
                    staticClass: "q-px-md",
                    attrs: {
                      color: "green",
                      label: "Add",
                      disable: _vm.$v.courseForm.$invalid
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.onAdd()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("q-btn", {
            attrs: { outline: "", color: "faded", label: "Close" },
            nativeOn: {
              click: function($event) {
                return _vm.closeDetails($event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "layout-padding", attrs: { id: "orderManagementBody" } },
        [
          _c("div", { staticClass: "sl-row sl-abs" }, [
            _c(
              "div",
              { staticClass: "sl-col-3 navigation sl-vp" },
              [
                _c(
                  "q-list",
                  { attrs: { highlight: "" } },
                  [
                    _c(
                      "q-item",
                      {
                        class: { active: _vm.selectedTab === "general" },
                        nativeOn: {
                          click: function($event) {
                            _vm.updateSelectedTab("general")
                            _vm.test()
                          }
                        }
                      },
                      [_c("q-item-main", { attrs: { label: "General" } })],
                      1
                    ),
                    _vm.mode != "add" && _vm.$p(["ADMIN"])
                      ? _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "managers" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("managers")
                              }
                            }
                          },
                          [
                            _c("q-item-main", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.addManager,
                                  expression: "!addManager"
                                }
                              ],
                              attrs: { label: "Managers" }
                            }),
                            _c(
                              "q-item-main",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.addManager,
                                    expression: "addManager"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "q-field",
                                  { attrs: { "error-label": "Invalid Date" } },
                                  [
                                    _c(
                                      "q-search",
                                      {
                                        model: {
                                          value: _vm.managerFilter,
                                          callback: function($$v) {
                                            _vm.managerFilter = $$v
                                          },
                                          expression: "managerFilter"
                                        }
                                      },
                                      [
                                        _c("q-autocomplete", {
                                          ref: "managerAutoComplete",
                                          attrs: {
                                            "stack-label": "Search Managers",
                                            debounce: 500,
                                            "max-results": _vm.maxResults
                                          },
                                          on: {
                                            search: _vm.onSearchManager,
                                            selected: _vm.onSelectManager
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item-side",
                              [
                                _c(
                                  "q-item-tile",
                                  [
                                    _c(
                                      "q-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.addManager,
                                            expression: "!addManager"
                                          }
                                        ],
                                        staticClass: "addItemBtn",
                                        attrs: { icon: "add" },
                                        on: {
                                          click: function($event) {
                                            _vm.onAddManager()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-tooltip",
                                          {
                                            attrs: {
                                              anchor: "center right",
                                              self: "center left",
                                              offset: [10, 10]
                                            }
                                          },
                                          [_vm._v("Add a Manager")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.addManager,
                                            expression: "addManager"
                                          }
                                        ],
                                        staticClass: "clearItemBtn",
                                        attrs: {
                                          flat: "",
                                          color: "red",
                                          icon: "clear"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.onClearManager()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-tooltip",
                                          {
                                            attrs: {
                                              anchor: "center right",
                                              self: "center left",
                                              offset: [10, 10]
                                            }
                                          },
                                          [_vm._v("Clear")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.mode != "add"
                      ? _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "affiliates" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("affiliates")
                              }
                            }
                          },
                          [
                            _c("q-item-main", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.addAffiliate,
                                  expression: "!addAffiliate"
                                }
                              ],
                              attrs: { label: "Affiliate" }
                            }),
                            _c(
                              "q-item-main",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.addAffiliate,
                                    expression: "addAffiliate"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "q-field",
                                  { attrs: { "error-label": "Invalid Date" } },
                                  [
                                    _c(
                                      "q-search",
                                      {
                                        attrs: {
                                          "stack-label": "Search Affiliate"
                                        },
                                        model: {
                                          value: _vm.affiliateFilter,
                                          callback: function($$v) {
                                            _vm.affiliateFilter = $$v
                                          },
                                          expression: "affiliateFilter"
                                        }
                                      },
                                      [
                                        _c("q-autocomplete", {
                                          ref: "affiliateAutoComplete",
                                          attrs: {
                                            "stack-label": "Search Affiliate",
                                            debounce: 500,
                                            "max-results": _vm.maxResults
                                          },
                                          on: {
                                            search: _vm.onSearchAffiliate,
                                            selected: _vm.onSelectAffiliate
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item-side",
                              [
                                _c(
                                  "q-item-tile",
                                  [
                                    _c(
                                      "q-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.addAffiliate,
                                            expression: "!addAffiliate"
                                          }
                                        ],
                                        staticClass: "addItemBtn",
                                        attrs: { icon: "add" },
                                        on: {
                                          click: function($event) {
                                            _vm.onAddAffiliate()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-tooltip",
                                          {
                                            attrs: {
                                              anchor: "center right",
                                              self: "center left",
                                              offset: [10, 10]
                                            }
                                          },
                                          [_vm._v("Add an Affiliate")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.addAffiliate,
                                            expression: "addAffiliate"
                                          }
                                        ],
                                        staticClass: "clearItemBtn",
                                        attrs: {
                                          flat: "",
                                          color: "red",
                                          icon: "clear"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.onClearAffiliate()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-tooltip",
                                          {
                                            attrs: {
                                              anchor: "center right",
                                              self: "center left",
                                              offset: [10, 10]
                                            }
                                          },
                                          [_vm._v("Clear")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.mode === "edit"
                      ? _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "documents" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("documents")
                              }
                            }
                          },
                          [
                            _c("q-item-main", { attrs: { label: "Documents" } })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.mode === "edit"
                      ? _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "classes" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("classes")
                              }
                            }
                          },
                          [_c("q-item-main", { attrs: { label: "Classes" } })],
                          1
                        )
                      : _vm._e(),
                    _vm.mode === "edit"
                      ? _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "notes" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("notes")
                              }
                            }
                          },
                          [_c("q-item-main", { attrs: { label: "Notes" } })],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "sl-col-9 sl-vp",
                staticStyle: { "padding-bottom": "60px" },
                attrs: { id: "class-modal-right" }
              },
              [
                _vm.selectedTab === "general"
                  ? _c(
                      "div",
                      [
                        _c("course-general", {
                          attrs: {
                            courseForm: _vm.courseForm,
                            validation: _vm.validation
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedTab === "classes"
                  ? _c("div", [_c("course-classes")], 1)
                  : _vm._e(),
                _vm.selectedTab === "managers"
                  ? _c("div", [_c("course-managers")], 1)
                  : _vm._e(),
                _vm.selectedTab === "affiliates"
                  ? _c("div", [_c("course-affiliates")], 1)
                  : _vm._e(),
                _vm.selectedTab === "documents"
                  ? _c("div", [_c("course-documents")], 1)
                  : _vm._e(),
                _vm.selectedTab === "notes"
                  ? _c("div", [_c("course-notes")], 1)
                  : _vm._e()
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }